import { useRef, useState } from 'react';
import { useLatest } from 'ahooks';

export const useCount = (iniCount: number, callback?) => {
  const [count, setCount] = useState(0);
  const [isCanGo, setIsCanGo] = useState(true);
  const timerRef = useRef<any>(null);
  const timeNumRef = useRef<number>(iniCount);
  const fnRef = useLatest(callback);

  const timeGo = () => {
    if (timeNumRef.current === 0) {
      clearInterval(timerRef.current);
      timeNumRef.current = 0;
      setCount(0);
      setIsCanGo(true);
      return fnRef.current?.();
    }
    if (timerRef.current > 0) {
      timeNumRef.current--;
      setCount(timeNumRef.current);
    }
  };

  const go = () => {
    // if (!isCanGo) return;
    clearInterval(timerRef.current);
    timeNumRef.current = iniCount;
    setCount(iniCount);
    setIsCanGo(false);
    timeGo();
    timerRef.current = setInterval(() => {
      timeGo();
    }, 1000);
  };

  const cancel = () => {
    clearInterval(timerRef.current);
    setIsCanGo(true);
    setCount(iniCount);
  };

  return {
    count,
    go,
    isCanGo,
    cancel,
  };
};
